import script from "./NkBox.vue?vue&type=script&setup=true&lang=js"
export * from "./NkBox.vue?vue&type=script&setup=true&lang=js"

const __exports__ = script;

export default __exports__